import React, { useState, useEffect } from "react"
import { Row, Col, Image } from 'antd'
import classes from './styles.module.css'
import { Link } from 'react-router-dom'

import i18next from "i18next"
import { useTranslation } from "react-i18next"
import parse from 'html-react-parser';
import micon from '../../img/m_icon.png';
import CardCarousel from "components/CardCarousel/CardCarousel"
import { Styles } from "styles/styles"

const Museums: React.FC = () => {
    const controller = new AbortController();
    const { signal } = controller;
    const { t } = useTranslation()

    var currentLanguageCode = i18next.resolvedLanguage

    const [categories, setCategories] = useState([]);
    const [pois, setPois] = useState([]);

    const activecategory = 1;
    const [showMore, setShowMore] = useState<boolean>(false)

    const getCategory = async () => {
        const url = `https://dimosapokoronou.mitos.cityguideplatform.com/api/maincategories?lang=${currentLanguageCode}`
        const response = await fetch(url,
            {
                signal,
                headers: {
                    'X-API-KEY': 'OHiqSkWShHTbMGLoB5Am',
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            })
        if (!response.ok) {
            throw new Error('Data could not be fetched!')
        }
        else {
            return response.json()
        }

    };

    const getCategoryPois = async () => {
        const url = `https://dimosapokoronou.mitos.cityguideplatform.com/api/pois?category_id=${activecategory}&lang=${currentLanguageCode}`
        const response = await fetch(url,
            {
                signal,
                headers: {
                    'X-API-KEY': 'OHiqSkWShHTbMGLoB5Am',
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            })
        if (!response.ok) {
            throw new Error('Data could not be fetched!')
        }
        else {

            return response.json()
        }
    };

    useEffect(() => {
        getCategory()
            .then((res) => {
                setCategories(res.success)
                // console.log(res.success)
            })

        getCategoryPois()
            .then((res1) => {
                setPois(res1.success)
                // console.log(res1.success)
            })
            .catch((e) => {
                console.log(e.message)
            })
    }, [i18next.language])

    return (
        <div className={classes.museumsContaier}>
            <h2 className="museumsTitle">{t('Μουσεία')}</h2>
            <div className={classes.carouselContainer}>
                <CardCarousel museums={pois} />
            </div>

            <div className={classes.cardContainer}>
                {pois.map((museum: any, index) => (
                    <Link className={classes.linkItem} key={index} to={`/museums/${museum.id}`}>
                        <div className={classes.carouselCardItem}>
                            <img
                            className="cardCarouselImage"
                            src={museum.main_image}
                            alt={`Slide ${index + 1}`}
                            />
                            <h3 className={classes.carouselCardTitle}>{museum.name}</h3>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    )
}

export default Museums